const pages = [
  "home",
  "jobs for electrician",
  "jobs for plumber",
  "jobs for mechanic",
  "jobs for cook",
  "jobs for peon",
  "jobs for driver",
  "jobs for drivers",
  "jobs for housekeeping",
  "jobs for site workers",
  "jobs for securityguard",
  "jobs for security guard",
  "job for electrician",
  "job for plumber",
  "job for mechanic",
  "job for cook",
  "job for peon",
  "job for driver",
  "job for drivers",
  "job for housekeeping",
  "job for siteworkers",
  "job for securityguard",
  "job for security guard",
  "electrician",
  "plumber",
  "mechanic",
  "cook",
  "peon",
  "driver",
  "drivers",
  "housekeeping",
  "siteworkers",
  "site workers",
  "securityguard",
  "security guard",
  "electrician jobs",
  "plumber jobs",
  "mechanic jobs",
  "cook jobs",
  "peon jobs",
  "driver jobs",
  "drivers jobs",
  "housekeeping jobs",
  "siteworkers jobs",
  "securityguard jobs",
  "security guard jobs",
  "bijali Karigar ki Naukari chahiye",
  "plumber ki job chahiye",
  "Kriya Vidhi ki Naukari chahiye",
  "Bawarchi ki Naukari chahiye",
  "chaprasi ki Naukari chahiye",
  "Pardesi ki Naukari chahiye",
  "chaprasi ki Naukari",
  "Pardesi ki Naukari",
  "driver ki Naukari chahiye",
  "drivers ki Naukari chahiye",
  "Chalak ki Naukari chahiye",
  "Chalak ki Naukari",
  "Palak ki Naukari chahiye",
  "Palak ki Naukari",
  "chalak ki Naukari chahiye",
  "chalak ki Naukari",
  "palak ki Naukari chahiye",
  "palak ki Naukari",
  "housekeeping ki Naukari chahiye",
   "siteworkers ki Naukari chahiye",
  "siteworker ki Naukari chahiye",
  "Nirman sthal karykarta ki Naukari chahiye",
  "Nirman Sthal karykarta ki Naukari chahiye",
  "Surakshaguard ki Naukari chahiye",
  "Suraksha guard ki Naukari chahiye",
  "bijali Karigar ki Naukari chahie",
  "Nal kar ki Naukari chahie",
  "kar ki Naukari chahie",
  "Lalkare ki Naukari chahie",
  "Kriya Vidhi ki Naukari chahie",
  "Bawarchi ki Naukari chahie",
  "chaprasi ki Naukari chahie",
  "Pardesi ki Naukari chahie",
    "driver ki Naukari chahie",
  "drivers ki Naukari chahie",
  "Chalak ki Naukari chahie",
   "Palak ki Naukari chahie",
   "chalak ki Naukari chahie",
   "calak ki Naukari chahie",
  "housekeeping ki Naukari chahie",
  "siteworkers ki Naukari chahie",
  "siteworker ki Naukari chahie",
  "Nirman sthal karykarta ki Naukari chahie",
  "Nirman sthal karykarta ki Naukari",
  "Nirman Sthal karykarta ki Naukari",
  "Nirman Sthal karykarta ki Naukari chahie",
  "Surakshaguard ki Naukari chahie",
  "Suraksha guard ki Naukari chahie",
  "Suraksha guard ki Naukari",
  "Kriya Vidhi ki Naukari",
  "electrician job",
  "plumber job",
  "mechanic job",
  "cook job",
  "peon job",
  "driver job",
  "drivers job",
  "housekeeping job",
  "siteworkers job",
  "securityguard job",
  "security guard job",
  "candidates for electrician",
  "candidates for plumber",
  "candidates for mechanic",
  "candidates for cook",
  "candidates for peon",
  "candidates for driver",
  "candidates for drivers",
  "candidates for housekeeping",
  "candidates for siteworkers",
  "candidates for securityguard",
  "candidates for security guard",
  "candidate for electrician",
  "candidate for plumber",
  "candidate for mechanic",
  "candidate for mechanics",
  "candidate for cook",
  "candidate for peon",
  "candidate for driver",
  "candidate for drivers",
  "candidate for housekeeping",
  "candidate for site workers",
  "candidate for securityguard",
  "candidate for security guard",
  "electrician candidate",
  "plumber candidate",
  "mechanic candidate",
  "cooking candidate",
  "peon candidate",
  "driver candidate",
  "drivers candidate",
  "housekeeping candidate",
  "siteworker candidate",
  "site worker candidate",
  "securityguard candidate",
  "security guard candidate",
  "electrician candidates",
  "plumber candidates",
  "mechanic candidates",
  "cooking candidates",
  "peon candidates",
  "driver candidates",
  "drivers candidates",
  "housekeeping candidates",
  "siteworker candidates",
  "site worker candidates",
  "securityguard candidates",
  "security guard candidates",
  "bijali Karigar chahie",
  "Nal kar chahie",
  "kar chahie",
  "Lalkare chahie",
  "Kriya Vidhi chahie",
  "cook chahie",
  "chaprasi chahie",
  "Pardesi chahie",
  "driver chahie",
  "drivers chahie",
  "Chalak chahie",
   "Palak chahie",
   "chalak chahie",
   "palak chahie",
  "housekeeper chahie",
  "siteworker chahie",
  "siteworkers chahie",
  "Nirman sthal karykarta chahie",
  "Nirman Sthal karykarta chahie",
  "Surakshaguard chahie",
  "Suraksha guard chahie",
  "bijali Karigar chahiye",
  "Nal kar chahiye",
  "Kriya Vidhi chahiye",
  "cook chahiye",
  "chaprasi chahiye",
  "Pardesi chahiye",
  "driver chahiye",
  "drivers chahiye",
  "Chalak chahiye",
   "Palak chahiye",
   "chalak chahiye",
   "palak chahiye",
  "housekeeper chahiye",
  "siteworker chahiye",
  "Nirman sthal karykarta chahiye",
  "Nirman Sthal karykarta chahiye",
  "Suraksha guard chahiye",
  "Surakshaguard chahiye",
  "Bawarchi chahie",
  "Bawarchi chahiye",
  "Bawarchi ki Naukari",
  "post jobs",
  "post job",
  "registration",
  "register"
];
export default pages;